import { render, staticRenderFns } from "./CiMandatoryExtrasList.vue?vue&type=template&id=58c43d16&"
import script from "./CiMandatoryExtrasList.vue?vue&type=script&lang=js&"
export * from "./CiMandatoryExtrasList.vue?vue&type=script&lang=js&"
import style0 from "./CiMandatoryExtrasList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CiMandatoryExtrasList.vue"
export default component.exports